import React, { Component } from "react";
import { Link } from "react-router-dom";
import { records  } from "../../services/message";
import AppContext from "../../contexts/AppContext";

export class HeaderMessages extends Component {
    state = { items: [], unread: 0 };
    componentDidMount() {
        var countDown = 0;
        setInterval(() => {
            if (countDown % 30 === 0) {
                records().then(response => {
                    let temp = this.state.items;
                    temp.push(...response.data);

                    this.setState({
                        unread: response.meta.unread
                    });

                });
            }
            countDown = countDown + 1;
        }, 1000);
    }


    render() {
        return (


                <div className="position-relative d-inline-block ">
                    <Link
                        className="nav-link link2"
                        to={`/${this.context.state.user.type}/messages`}
                    >
                        <span className="fe fe-mail messagesCounts">
                        {this.state.unread === 0 ? null : (
                            <span className="badge badge-primary noteCount">
                            {this.state.unread}
                            </span>
                        )}
                        </span>
                    </Link>
                </div>



        );
    }
}

HeaderMessages.contextType = AppContext;
export default HeaderMessages;



// WEBPACK FOOTER //
// ./src/components/messages/HeaderMessages.js